import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from '../table/columns/CustomHeaderColumn'
import {CustomRow} from '../table/columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {appsColumns} from './columns/_columns'
import {App} from '../core/_models'
import {AppsListLoading} from '../components/loading/AppsListLoading'
import {AppsListPagination} from '../components/pagination/AppsListPagination'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import { StepProps } from '../../../../../../_metronic/partials/modals/create-event-stepper/IAppModels'

const AppsTable = ({data, updateData, hasError}: StepProps) => {
  const apps = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data1 = useMemo(() => apps, [apps])
  const columns = useMemo(() => appsColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data: data1,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive mh-300px'>
        <table
          id='kt_table_apps'
          // className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          className='table fs-6 gy-5 dataTable table-row-bordered table-row-gray-100 align-middle gs-0 '
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-normal fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<App>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody 
          className='text-gray-600 fw-light' {...getTableBodyProps()}
          >
            {rows.length > 0 ? (
              rows.map((row: Row<App>, i) => {
                prepareRow(row)
                return <CustomRow hasError={hasError} data={data} updateData={updateData} row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* <AppsListPagination /> */}
      {isLoading && <AppsListLoading />}
    </KTCardBody>
  )
}

export {AppsTable}
